import React from "react";
import WidgetIcon from "../../icons/widget-icon/WidgetIcon";
import ConstantsImages from "../../../constants/ConstantsImages";
import WidgetTooltipWrapper from "../widget-tooltip-wrapper/WidgetTooltipWrapper";
import ConstantsTexts from "../../../constants/ConstantsTexts";

const WidgetChangelogIcon = ({ showUpdatesList, handleShowUpdatesListClick }) => {
  const icon = showUpdatesList ? ConstantsImages.CLOSE_CHANGELOG_IMAGE : ConstantsImages.CHANGELOG_IMAGE;
  const backgroundColor = showUpdatesList ? "#DBDBDB" : "#FFFFFF";

  const getIconDimensions = () => {
    if (showUpdatesList) {
      return { width: "1.1rem", height: "1.2rem" };
    }
    return { width: "2.1rem", height: "2.4rem" };
  };

  const iconElement = (
    <WidgetIcon
      iconProp={icon}
      backgroundColorProp={backgroundColor}
      handleOnClickProp={() => handleShowUpdatesListClick(!showUpdatesList)}
      widthIconProp={getIconDimensions().width}
      heightIconProp={getIconDimensions().height}
      customClassNameProp="widget-changelog-icon"
      dataHoverDisabled={showUpdatesList}
    />
  );

  // Only show tooltip when updates list is closed
  if (showUpdatesList) {
    return iconElement;
  }

  return <WidgetTooltipWrapper content={ConstantsTexts.CODE_28}>{iconElement}</WidgetTooltipWrapper>;
};

export default WidgetChangelogIcon;
